import {Component} from '@angular/core';
import {FileItem} from '@aposin/ng-aquila/file-uploader';
import {DynamicComponentBaseComponent} from '../../../../../dynamic-components/components/dynamic-component-base/dynamic-component-base.component';
import {UploadedRowPart} from '../../../../interfaces/forms/file-upload';

@Component({
    selector: 'app-upload-delete',
    templateUrl: './upload-delete.component.html',
    styleUrls: ['./upload-delete.component.scss'],
    standalone: false
})
export class UploadDeleteComponent extends DynamicComponentBaseComponent<UploadedRowPart> {
  onRemoveFile(_evt: unknown, file: FileItem) {
    this.data.templateContext.removeFile(file);
  }
}
